/**
 * Types for the Social Planner (SPEC PX-3 — social-planner R2).
 *
 * A social_post is a multi-network scheduled feed/carousel post. It is NOT a
 * conversation (gap #8): no contact_id, no thread.
 */

export type SocialPostStatus =
  | 'draft'
  | 'scheduled'
  | 'publishing'
  | 'published'
  | 'failed';

export type PerNetworkStatus =
  | 'pending'
  | 'publishing'
  | 'published'
  | 'failed'
  | 'no_token'
  | 'skipped';

export interface PerNetworkResult {
  status: PerNetworkStatus;
  external_post_id?: string | null;
  error?: string | null;
  published_at?: string | null;
}

export interface SocialPost {
  id: string;
  tenant_id: string;
  title: string;
  caption: string;
  media_urls: string[];
  networks: string[];
  scheduled_at?: string | null;
  status: SocialPostStatus;
  per_network: Record<string, PerNetworkResult>;
  published_at?: string | null;
  error?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface SocialPostListResponse {
  posts: SocialPost[];
  total: number;
}

export interface SocialPostCreate {
  title: string;
  caption?: string;
  template_id?: string;
  media_urls: string[];
  networks: string[];
  scheduled_at: string;
  status: 'draft' | 'scheduled';
}

export interface SocialPostUpdate {
  title?: string;
  caption?: string;
  template_id?: string;
  media_urls?: string[];
  networks?: string[];
  scheduled_at?: string;
  status?: 'draft' | 'scheduled';
}

/** The networks the planner UI offers (mirrors the backend registry). */
export const SOCIAL_NETWORKS: { value: string; label: string }[] = [
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook Page' },
  { value: 'linkedin', label: 'LinkedIn' },
];
